export default __webpack_public_path__ + "static/media/right-arrow.9690e8c1.svg";